import React from 'react';
// @mui
import { TableCell } from '@mui/material';
import { getNestedValue, isValidJSON } from '../../utils/formatName';
import config from '../../config';
import { getI18n } from 'react-i18next';

export default class GridArrayCell extends React.Component {
    getDisplayValue = (value, primary, secondary) => {
        const primaryValue = primary ? getNestedValue(value, primary) : null;
        const secondaryValue = secondary
            ? getNestedValue(value, secondary)
            : null;

        if (primary && secondary) {
            return primaryValue && secondaryValue
                ? `${primaryValue}: ${secondaryValue}`
                : primaryValue || secondaryValue || '';
        }

        return primaryValue || secondaryValue || value.name || value || '';
    };
    getValue = (value) => {
        const i18CurrentLanguage = getI18n().language || config.language;
        if (isValidJSON(value)) {
            const parsedValue = JSON.parse(value);
            return parsedValue[i18CurrentLanguage] || '';
            // const validNames = Object.values(parsedValue).filter((name) =>
            //     name?.trim()
            // );
            // return validNames.join(' / ') || '';
        }
        return value;
    };

    render() {
        // props: value, id, field
        //show value with comma separated
        if (!this.props.value || !this.props.value.length) {
            return <TableCell />;
        }
        return (
            <TableCell key={this.props.field.id} align="left">
                {this.props.value.map((item, index) => {
                    if (!item) return null;
                    const value = this.getDisplayValue(
                        item,
                        this.props.field.primary,
                        this.props.field.secondary
                    );
                    const displayValue = this.getValue(value);
                    return (
                        <span key={index}>
                            {displayValue}
                            {index < this.props.value.length - 1 ? ', ' : ''}
                        </span>
                    );
                })}
            </TableCell>
        );
    }
}
